import { ISafegraphLocationVisitDataRecord } from "./ISafegraphLocationVisitDataRecord";

export interface ISafegraphLocationVisitData {
    locationId: string;
    brandId: string;
    last12Months: ISafegraphLocationVisitDataRecord<string>[];
    byMonth: ISafegraphLocationVisitDataRecord<Date>[];
    byWeek: ISafegraphLocationVisitDataRecord<Date>[];
    byDay: ISafegraphLocationVisitDataRecord<Date>[];
    byDayOfWeek: ISafegraphLocationVisitDataRecord<number>[];
    byHour: ISafegraphLocationVisitDataRecord<number>[];
};